const PaymentRequests = () => {
  return <div>Solicitudes de pago</div>;
};

export default PaymentRequests;
